import moment from 'moment';

const DATE_FORMAT = 'DD/MM/YYYY';
const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';

export function configureMoment(userLocale: string): void {
    moment.updateLocale(userLocale, {
        calendar: {
            sameElse: 'L LT', // Make calendar dates older than a week also show the time.
        },
    });

    // Set the locale moment uses.
    moment.locale(userLocale);
}

export function nthWeekdayOfMonth(year: number, month: number, nth: number, dow: number): Date {
    const d = new Date(year, month - 1, 7 * (nth - 1) + 1);
    const w = d.getDay();
    d.setDate(d.getDate() + ((7 + dow - w) % 7));
    if (d.getMonth() + 1 > month || d.getFullYear() > year) d.setDate(d.getDate() - 7);
    return d;
}

export function atTimeOfDay(day: moment.Moment, time: string): moment.Moment {
    const timeOfDay = moment.duration(time);
    return day
        .clone()
        .startOf('day')
        .set({ hour: timeOfDay.hours(), minute: timeOfDay.minutes(), second: timeOfDay.seconds() });
}

export function timestampToDate(timestamp?: number): string {
    return formatTimestamp(timestamp, DATE_FORMAT);
}

export function timestampToDateTime(timestamp?: number): string {
    return formatTimestamp(timestamp, DATE_TIME_FORMAT);
}

function formatTimestamp(timestamp: number | undefined, format: string): string {
    return timestamp ? moment.unix(timestamp).format(format) : '';
}
